<template>
    <el-row>
        <!-- 搜索栏 -->
        <craft-search
                :table_work="workSpace"
                :search-url="rootUrl"
                :handle-success="handleSearchResponse"
                :refresh-url="defaultUrl"
                :handle-refresh-response="handleRefresh">
            <div style="float: left;margin-left: 15px">
                <el-tag type="info" size="small">数量:{{ craftLength }} / {{ count }}</el-tag>
            </div>

            <div style="float: left;margin-left: 15px">
                <i v-show="loading" class="el-icon-loading"></i>
            </div>
        </craft-search>

        <!--  内容列表 -->
        <craft-table ref="CraftSingleTable" :click-current-row="rowClick" :crafts="crafts"/>

        <!--  下一页 -->
        <next-foo :handle-response="handleNextResponse" :next-url="nextUrl" :no-more="noMore"/>


        <el-dialog
                width="70%"
                title="编辑工艺记录单"
                :lock-scroll="false"
                :visible.sync="CraftShowDrawer"
                :with-header="false"
                :destroy-on-close="false"
        >
            <el-row style="margin-bottom: 8px;width: 80%">
                <!-- 新增小组任务 按钮 -->
                <create-new-group-button/>

                <!-- 提交 -->
                <submit-current-craft-button :checkSubmit="checkCraftPlanNum" :is-draft="isDraft"/>

                <!-- 审核 -->
                <verify-current-craft-button :is-submit="isSubmit" :checkVerify="checkCraftPlanNum"/>

                <!-- 反审 -->
                <reserve-verify-current-craft-btn :is-reverse-verify="isReverseVerify"/>

                <!-- 上报 -->
                <finish-current-craft-button :is-verify="isVerify" :check-finish="checkGroupsFinish"/>
            </el-row>

            <el-row>
                <el-collapse @change="changeCollapse" accordion v-model="activeName">
                    <el-collapse-item name="0">
                        <template slot="title">
                            <span class="text-warning">{{ craft.name }}通知数量:{{ craftPlanNum}}</span>
                            <el-divider direction="vertical"></el-divider>
                            未分配数量:<span class="text-success" v-if="leftoverPlanNum===0"> {{ leftoverPlanNum }}</span>
                            <span class="text-danger" v-else> {{ leftoverPlanNum }}</span>
                        </template>

                        <current-craft-record-detail :is-mdf-statue="isMdfStatue" :defaultPrice="defaultPrice"/>
                    </el-collapse-item>
                    <template v-for="groupCraftRecord in craft.groupcraftrecord_set">
                        <el-collapse-item :key="groupCraftRecord.id" :name="String(groupCraftRecord.id)">

                            <template slot="title">
                                {{ groupCraftRecord.produce_group_name }}
                                <el-divider direction="vertical"></el-divider>
                                分派数量: {{ groupCraftRecord.plan_num}}
                            </template>

                            <group-craft :group-craft-record="groupCraftRecord"/>
                        </el-collapse-item>
                    </template>

                </el-collapse>
                <el-dialog
                        title="创建小组分派单"
                        :append-to-body="true"
                        size="55%"
                        :destroy-on-close="true"
                        @open="setShowCraftCreateGroup(true)"
                        @close="setShowCraftCreateGroup(false)"
                        :visible="ShowCraftCreateGroup">
                    <create-group-craft></create-group-craft>
                </el-dialog>
            </el-row>
        </el-dialog>
    </el-row>

</template>

<script>
    import CraftSearch from "../components/crafts/CraftSearch"
    import CreateGroupCraft from "../components/crafts/CreateGroupCraft"
    import CreateNewGroupBatch from "../components/crafts/CreateNewGroupBatch"
    import GroupCraft from "../components/crafts/GroupCraft"
    import CraftTable from "../components/crafts/CraftTable"
    import CurrentCraftRecordDetail from "../components/crafts/CurrentCraftRecordDetail"
    import NextFoo from "../components/NextFoo"
    import CreateNewGroupButton from "../components/crafts/CreateNewGroupButton"
    import SubmitCurrentCraftButton from "../components/crafts/SubmitCurrentCraftButton"
    import VerifyCurrentCraftButton from "../components/crafts/VerifyCurrentCraftButton"
    import ReserveVerifyCurrentCraftBtn from "../components/crafts/ReserveVerifyCurrentCraftBtn"
    import FinishCurrentCraftButton from "../components/crafts/FinishCurrentCraftButton"

    import {mapGetters, mapMutations, mapState} from 'vuex'

    export default {
        name: "CraftWorkSpace",
        props: {
            workSpace: Number,
        },
        data() {
            return {
                activeName: '0',
                defaultPrice: 0,
                rootUrl: `/order_platform/api/craft_records?work_table=${this.workSpace}`,
                loading: false,
                nextUrl: '',            // 下一页的 api 地址
                count: 0,
                CraftShowDrawer: false, // 用来控制展开详细信息的开关
            }
        },
        computed: {
            /**
             * currentCraft的别名 当前正在操作的工艺记录单
             */
            craft() {
                return this.currentCraft
            },

            /**
             * 当前正在操作的工艺记录单的尺码信息
             */
            size_records() {
                return this.craft.size_records
            },

            /**
             * 当前工艺记录单的通知数据汇总
             * 与 currentCraft.plan_num 的区别：原生 plan_num 是固定值
             * 而这里的值是随 各尺码的 num 变化而变化的
             */
            craftPlanNum() {
                let _PlanNum = 0
                if (this.craft.size_records) {
                    this.craft.size_records.forEach((sizeRecord) => {
                        _PlanNum += parseInt(sizeRecord.num)
                    })
                }
                return _PlanNum
            },

            /**
             * 当前工艺记录单未分配的(通知)数量
             */
            leftoverPlanNum() {
                return this.craft.plan_num - this.craft.has_planed
            },

            /**
             * 获取工艺记录单的默认 API 接口地址
             * 例如在 初始化 或者 刷新页面时，都使用该接口获取数据
             */
            defaultUrl() {
                return this.unFinishUrl
            },

            /**
             * 按照条件( finish=false)获取工艺记录单的接口
             */
            unFinishUrl() {
                return `${this.rootUrl}&finish=false`
            },

            /**
             * 是否还有更多(未加载的数据)
             */
            noMore() {
                return !Boolean(this.nextUrl)
            },

            /**
             * 当前记录单数组的长度
             */
            craftLength() {
                return this.crafts.length
            },

            /**
             * 当前记录单数组 这个是 meta 最初始的数据
             */
            crafts() {
                return this.craftsByWorkSpace(this.workSpace)['crafts']
            },
            ...mapState({
                currentCraft: 'currentCraft',
                ShowCraftCreateGroup: 'ShowCraftCreateGroup',
                produceFactories: 'produceFactories',
            }),
            ...mapGetters({
                craftsByWorkSpace: 'craftsByWorkSpace',
                isMdfStatue: 'currentCraftIsMdf',
                isDraft: 'currentCraftIsDraft',
                isSubmit: 'currentCraftIsSubmit',
                isReverseVerify: 'currentCraftIsReverseVerify',
                isVerify: 'currentCraftIsVerify',

            })
        },
        components: {
            FinishCurrentCraftButton,
            ReserveVerifyCurrentCraftBtn,
            VerifyCurrentCraftButton,
            SubmitCurrentCraftButton,
            CreateNewGroupButton,
            CurrentCraftRecordDetail,
            NextFoo,
            CraftTable,
            GroupCraft,
            CreateNewGroupBatch,
            CraftSearch,
            CreateGroupCraft
        },
        methods: {

            /**
             * 小组信息切换事件
             * 更新小组(groupCraftRecord) 到 currentGroup
             */
            changeCollapse(name) {
                const nameNumber = Number(name)
                if (nameNumber > 0) {    // 默认的 nameNumber 为 0
                    // 获取 groupCraftRecord
                    for (let i = 0; i < this.craft.groupcraftrecord_set.length; i++) {
                        const groupCraftRecord = this.craft.groupcraftrecord_set[i]
                        if (groupCraftRecord.id === nameNumber) {
                            this.setCurrentGroupCraft(groupCraftRecord)
                        }
                    }
                }

            },

            /**
             * 处理 加载下一页的响应信息
             * @response {Object} Response 响应信息
             */
            handleNextResponse(response) {
                this.handleResponse(response)
            },

            /**
             * 处理 刷新页面的响应信息
             * @response {Object} Response 响应信息
             */
            handleRefresh(response) {
                const handle = this.setCrafts
                this.handleResponse(response, handle)
            },

            /**
             * 初始化时，加载默认的工艺记录单数据['避免显示空白']
             * unFinishUrl 为默认加载的 API 接口地址
             */
            loadCrafts() {
                if (this.craftLength <= 0) {
                    this.loading = true
                    this.$getRequest(this.unFinishUrl)
                        .then((response) => {
                            this.loading = false
                            this.handleResponse(response)
                        }).catch(error => {
                        this.loading = false
                    })
                }
            },

            /**
             * 处理 搜索的响应信息
             * @response {Object} Response 响应信息
             */
            handleSearchResponse(response) {
                const handle = this.setCrafts
                this.handleResponse(response, handle)
                this.$message.success(`共搜索到${response.data.results.length} / ${response.data.count} 个工艺单`)

            },

            /**
             * 处理响应信息
             * @response {Object} Response 响应信息，其中 response.data.results 为 工艺记录单列表
             */
            handleResponse(response, handle = this.addCrafts) {
                this.nextUrl = this.$utils.handleOrderUrl(response.data.next)
                this.count = response.data.count
                this.setupWorkSpace(response.data.results)
                handle(response.data.results)
            },

            /**
             * 检查当前操作的工艺记录单的通知数据
             */
            checkCraftPlanNum() {
                // 检测总数量是否对得上
                if (!(this.leftoverPlanNum === 0)) {
                    this.$message.error(`错误：剩余分配数量为${this.leftoverPlanNum}`)
                    return false
                }

                // 检测各尺码是否对得上
                for (let i = 0; i < this.size_records.length; i++) {
                    const sizeRecord = this.size_records[i]
                    if (sizeRecord.num !== sizeRecord.has_planed) {
                        this.$message.error(`错误：${sizeRecord.shop_id}的通知数量为${sizeRecord.num},分配数量为${sizeRecord.has_planed}`)
                        return false
                    }
                }
                return true

            },

            /**
             * 检查当前操作的工艺记录单的任务小组上报时，数据准确性
             */
            checkGroupsFinish() {
                if (!this.checkCraftPlanNum()) {
                    return false
                }

                for (let i = 0; i < this.craft.groupcraftrecord_set.length; i++) {
                    const groupCraftRecord = this.craft.groupcraftrecord_set[i]
                    if (!groupCraftRecord.finish) {
                        this.$message.error(`错误:'${groupCraftRecord.produce_group_name}'小组未"上报"`)
                        return false
                    }
                }
                return true
            },

            /**
             * 为每个工艺记录单 配置控制台字段属性
             * @param { [Object] } crafts
             */
            setupWorkSpace(crafts) {
                crafts.forEach((craft) => {
                    craft[this.$const.WorkSpaceAttrName] = this.workSpace
                })
            },


            /**
             * 设置当前工作台的 工艺记录单数据
             * 与 add 相比，该操作会进行清空，然后再赋值
             */
            setCrafts(crafts) {
                return this._setCrafts({workSpace: this.workSpace, crafts: crafts})
            },

            /**
             * 点击当前行的功能键时的触发事件
             * @param row 当前行 Craft 对象
             */
            rowClick(row,) {
                // 将被点击的行信息 [craft] 赋值为 CurrentCraft
                this.setCurrentCraft(row)

                // 在显示当前 currentCraft 信息时的初始化工作
                this.activeName = '0'
                this.defaultPrice = 0

                // 展现改行的详细信息
                this.CraftShowDrawer = true
            },
            ...mapMutations(
                {
                    addCrafts: 'addCrafts',
                    updateCurrentCraft: 'updateCurrentCraft',
                    _setCrafts: 'setCrafts',
                    setProduceFactories: 'setProduceFactories',
                    setCurrentCraft: 'setCurrentCraft',
                    removeCraft: 'removeCraft',
                    setCurrentGroupCraft: 'setCurrentGroupCraft',
                    setShowCraftCreateGroup: 'setShowCraftCreateGroup'
                },
            )
        },
        updated() {
            if (this.currentCraft) {
                this.$refs.CraftSingleTable.setCurrentRow(this.currentCraft)
            }
        },
        beforeMount() {
            // 加载组件所需要的 工艺记录信息
            this.loadCrafts()
        },
    }
</script>

<style scoped>

</style>